import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services';
import { TokenType } from './token.enum';

export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const authService = inject(AuthenticationService);
    let headers = req.headers;
    headers = headers.append(TokenType.API_KEY, authService.getApiKey)
    if (authService.getAuthToken) {
        headers = headers.append(TokenType.AUTHORIAZTION, authService.getAuthToken)
    }

    const newReq = req.clone({
        headers: headers,
    });
    return next(newReq);
}